import { _ as r } from "../internals/export.js";
import { f as t } from "../internals/function-call.js";
import { f as e } from "../internals/function-uncurry-this.js";
import { r as n } from "../internals/require-object-coercible.js";
import { i } from "../internals/is-callable.js";
import { i as s } from "../internals/is-null-or-undefined.js";
import { i as o } from "../internals/is-regexp.js";
import { t as a } from "../internals/to-string.js";
import { g as l } from "../internals/get-method.js";
import { r as m } from "../internals/regexp-get-flags.js";
import { g as f } from "../internals/get-substitution.js";
import { w as p } from "../internals/well-known-symbol.js";
var g = p("replace"),
  c = TypeError,
  u = e("".indexOf);
e("".replace);
var j = e("".slice),
  h = Math.max,
  b = function b(r, t, e) {
    return e > r.length ? -1 : "" === t ? e : u(r, t, e);
  };
r({
  target: "String",
  proto: !0
}, {
  replaceAll: function replaceAll(r, e) {
    var p,
      d,
      x,
      w,
      v,
      y,
      A,
      k = n(this),
      q = 0,
      E = 0,
      M = "";
    if (!s(r)) {
      if (o(r) && !~u(a(n(m(r))), "g")) throw c("`.replaceAll` does not allow non-global regexes");
      if (p = l(r, g)) return t(p, r, k, e);
    }
    for (d = a(k), x = a(r), (w = i(e)) || (e = a(e)), y = h(1, v = x.length), q = b(d, x, 0); -1 !== q;) A = w ? a(e(x, q, d)) : f(x, d, q, [], void 0, e), M += j(d, E, q) + A, E = q + v, q = b(d, x, q + y);
    return E < d.length && (M += j(d, E)), M;
  }
});